import { getMinMaxPlayers } from "./utils.js";
import { match } from "ts-pattern";
import { NextSeo, ProductJsonLd } from "next-seo";
import { ProductContext } from "./provider.js";
import { useTranslation } from "next-i18next";
import React from "react";
export const ProductSeo = ({ domain, ...nextSeoProps }) => {
    const product = React.useContext(ProductContext);
    const { ean, edition, images, prices, releaseDate, slug, tagline, teaser, title } = product;
    const { t } = useTranslation(["c-product", "c-common"]);
    const { minPlayers, maxPlayers } = getMinMaxPlayers(product);
    const categoryPath = edition === "online" ? t("c-common:slug-online") : t("c-common:slug-print");
    const seoTitle = `${title} | ${t("c-common:seo-slogan", "Krimidinner für Zuhause")}`;
    const printPrefix = t("c-common:seo-product-description-prefix-print", "Krimidinner für {{minPlayers}}-{{maxPlayers}} Personen.", { minPlayers, maxPlayers });
    const onlinePrefix = t("c-common:seo-product-description-prefix-online", "Online-Krimidinner für {{minPlayers}}-{{maxPlayers}} Personen.", { minPlayers, maxPlayers });
    const seoDescription = `${edition === "online" ? onlinePrefix : printPrefix} ${tagline}`;
    const locale = match(domain)
        .with("culinario-mortale.fr", () => "FR")
        .with("culinario-mortale.jp", () => "JP")
        .with("culinario-mortale.ru", () => "RU")
        .with("culinario-mortale.de", () => "DE")
        .with("culinario-mortale.co.uk", "culinario-mortale.com", () => "GB")
        .exhaustive();
    const sellerName = match(domain)
        .with("culinario-mortale.fr", () => "Blackrock Games")
        .with("culinario-mortale.jp", () => "DearSpiele")
        .with("culinario-mortale.ru", () => "Magellan Games")
        .with("culinario-mortale.co.uk", "culinario-mortale.de", "culinario-mortale.com", () => "Culinario Mortale")
        .exhaustive();
    const price = prices.find(({ market }) => market === locale);
    if (!price)
        throw new Error(`Failed to parse price for seo: ${JSON.stringify({ prices, domain, locale }, null, 3)}`);
    const canonical = edition === "online"
        ? { canonical: `https://www.${domain}/${t("c-common:slug-print")}/${slug}` }
        : {};
    return (React.createElement(React.Fragment, null,
        React.createElement(NextSeo, { ...canonical, description: seoDescription, title: seoTitle, openGraph: {
                description: teaser,
                images: images.map(({ alt, image }) => ({
                    url: image.src,
                    width: image.width,
                    height: image.height,
                    alt,
                })),
                title: title,
                type: "website",
                url: `https://www.${domain}/${categoryPath}/${slug}`,
            }, ...nextSeoProps }),
        edition === "print" && (React.createElement(ProductJsonLd, { brand: "Culinario Mortale", description: tagline, gtin13: ean, images: images.map(({ image }) => image.src), manufacturerLogo: "https://www.culinario-mortale.de/logo-square.png", manufacturerName: "Bischoff, Kauffmann & Otani GbR", material: "paper", offers: [
                {
                    availability: "https://schema.org/InStock",
                    itemCondition: "https://schema.org/NewCondition",
                    price: price[edition],
                    priceCurrency: price.currency,
                    seller: { name: sellerName },
                    url: `https://www.${domain}/${categoryPath}/${slug}/`,
                },
            ], productName: title, releaseDate: releaseDate ? new Date(releaseDate).toISOString() : undefined, sku: ean, slogan: t("c-common:seo-slogan", "Krimidinner für Zuhause") }))));
};
//# sourceMappingURL=seo.js.map